import Vue from 'vue'
import Valid from './valid'
import Response from './plugin/ResponseHelper.js'
import Utils from './plugin/utils.js'

import Element from 'element-ui';
Vue.use(Element, { size: 'small', zIndex: 3000 });
import 'element-ui/lib/theme-chalk/index.css';
// 按需引入部分组件
import "mint-ui/lib/style.css"
import Mint from 'mint-ui';
Vue.use(Mint);


Vue.use(Valid)
Vue.use(Response)

//注册全局方法
Vue.prototype.$utils=Utils
Vue.prototype.bus = new Vue();
Vue.config.productionTip = false;//关闭生产模式下给出的提示
// 引入全局过滤器
import filters from "@/plugin/utils";
Object.keys(filters).forEach((item) => Vue.filter(item, filters[item]));


export default Vue;



// WEBPACK FOOTER //
// ./src/comm.js